import { summaryAthleteSlice } from './summaryAthleteSlice'

export const { setSummaryProfessionalAthlete } = summaryAthleteSlice.actions
